// Keep the menu-builder's PIN-lock state in sync with the platform.
//
// The platform's PinLock model broadcasts to
//   pinlock_channel_<restaurant_id>_<restaurant_user_id>
// on BOTH lock (after_create_commit) and unlock (after_discard/after_destroy),
// and writes/clears the shared Redis key the builder reads via `pinlocked?`.
//
// The platform's own tabs subscribe to PinLockChannel and update live; the
// builder didn't, so unlocking from the platform never reached it. We subscribe
// cross-app to the same channel (same pattern as channels/platform_notifications.js)
// and reload on any event, so the builder's server-side `pinlocked?` re-runs and
// shows/hides components/global/pinlock_overlay accordingly.
//
// No jQuery here (we only touch the DOM via vanilla APIs), so import order /
// the window.$ hoisting issue doesn't apply.

import { createConsumer } from "@rails/actioncable"

let consumer = null

function getWssUrl(platformUrl) {
  return platformUrl.replace(/^http/, "ws") + "/cable"
}

export function subscribeToPlatformPinLock() {
  const el = document.getElementById("mb-pinlock-channel")
  if (!el) return

  const platformUrl = el.getAttribute("data-platform-url")
  const restaurantId = el.getAttribute("data-restaurant-id")
  const restaurantUserId = el.getAttribute("data-restaurant-user-id")
  if (!platformUrl || !restaurantId || !restaurantUserId) return

  if (!consumer) {
    consumer = createConsumer(getWssUrl(platformUrl))
  }

  consumer.subscriptions.create(
    {
      channel: "PinLockChannel",
      restaurant_id: restaurantId,
      restaurant_user_id: restaurantUserId,
    },
    {
      connected() {
        console.log("Connected to platform PinLockChannel")
      },

      disconnected() {
        console.log("Disconnected from platform PinLockChannel")
      },

      received() {
        // Lock or unlock happened on the platform — reload so the builder's
        // server-side `pinlocked?` re-evaluates and the overlay follows suit.
        console.log("PinLock state changed on platform; reloading")
        window.location.reload()
      },
    }
  )
}

document.addEventListener("DOMContentLoaded", subscribeToPlatformPinLock)
